module.exports = __webpack_public_path__ + "files/d225f1b69a4189b7aed78e5683150bb6.svg";